import * as React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { paginatePosts } from '../api/discussions'
import { PostModel } from '../models/moderation'
import { avatarImageUrl } from '../api'

import {
  Card,
  CardContent,
  Typography,
  Stack,
  Grid,
  Avatar
} from '@mui/material';

interface PostPaginaiton {
  results: PostModel[],
  current: PostModel
}

export default function PostList(props: { post: PostModel, discussionInfo: JSX.Element, select: string, course: string | null | undefined }) {
  const { oktaAuth } = useOktaAuth();
  const [posts, setPosts] = React.useState<Array<PostModel>>([]);
  const selectedPostRef = React.useRef<HTMLDivElement>(null);
  const postListRef = React.useRef<HTMLDivElement>(null);
  const [loading, setLoading] = React.useState(false);
  const [topCursor, setTopCursor] = React.useState<string>(props.post?.id);
  const [bottomCursor, setBottomCursor] = React.useState<string>(props.post?.id);
  const [hasNewPosts, setHasNewPosts] = React.useState(true);
  const [hasOlderPosts, setHasOlderPosts] = React.useState(true);
  const addNewerPosts = ({ results, current }: PostPaginaiton) => {
    if (!results.length) setHasNewPosts(false);
    const newPosts = [...results, ...posts];
    setPosts(() => [...newPosts]);
    setTopCursor(newPosts[0]?.id || topCursor);
    setHasNewPosts(results.length >= 10);
  }
  const addOlderPosts = ({ results, current }: PostPaginaiton) => {
    if (!results.length) setHasOlderPosts(false);
    const newPosts = [...posts, current, ...results];
    setPosts(() => [...newPosts]);
    setBottomCursor(newPosts[newPosts.length -1]?.id || bottomCursor);
    setHasOlderPosts(results.length >= 10);
  }
  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - scrollTop <= clientHeight * 1.1 && !loading && hasOlderPosts) {
      fetchPrevPostsPage(props.post.discussionGroupId);
    }
    if (scrollTop > 0 && scrollTop <= 5 && !loading && hasNewPosts) {
      fetchNextPostsPage(props.post.discussionGroupId);
    }
  };
  const fetchNextPostsPage = (async (discussionGroupId: string) => {
    if (loading) return;
    setLoading(true);
    await paginatePosts(oktaAuth, discussionGroupId, 10, topCursor)
      .then(addNewerPosts);
    setLoading(false);
  });

  const fetchPrevPostsPage = (async (discussionGroupId: string) => {
    if (loading) return;
    setLoading(true);
    await paginatePosts(oktaAuth, discussionGroupId, -10, bottomCursor)
      .then(addOlderPosts);
    setLoading(false);
  });
  React.useEffect(() => {
    if (props?.post?.discussionGroupId) {
      fetchPrevPostsPage(props.post.discussionGroupId)
        .then(() => {
          if (postListRef.current) postListRef.current.scrollTop = 10
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.post]);
  return (
    <Grid onScroll={handleScroll} container spacing={2} style={ { marginTop: "2rem", height: "100%", overflowY: "scroll", width: '50vw', padding: '2rem 4rem' } } ref={postListRef}>
      <Grid item xs={12}>
        { props.discussionInfo }
      </Grid>
      { posts.map((post, pi) => (
        <Grid item xs={12}  key={pi}>
          <Card ref={ (props.select === post?.id ? selectedPostRef : null) } className={  props.post.selected === post?.id ? 'selected-post': '' } sx={{ borderRadius: '12px', mb: 2, backgroundColor: '#F9F4F2', maxHeight: '350px', overflow: 'scroll' }}>
            <CardContent>
                <Typography variant='caption'>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    spacing={2}
                  >
                    <div style={ { display: 'flex'} }>
                      <Avatar src={ avatarImageUrl(post.author.avatarImageId) } />
                      <div style={ { paddingLeft: '1rem' } }>
                        <Typography variant='caption' fontWeight='600'>{post.author.name}</Typography>
                        <br />
                        <Typography variant='caption'>{post.courseInfo?.name}</Typography>
                      </div>
                    </div>
                    <div>{ new Date(post.createdOn).toDateString() }</div>
                  </Stack>
                </Typography>
                <Typography style={ { marginTop: '1rem' }} >{ post.messageBody }</Typography>
            </CardContent>
              {
                props.post.id === post.id ? renderReplies(props.post.replies, props.post.selected) : null
              }
          </Card>
        </Grid>
      ))
    }
  </Grid>
  );
}


function renderReplies(replies: PostModel[] = [], selected: string) {
  return replies.map((post, index) => (
  <Card key={index} className={  selected === post?.id ? 'selected-post': '' } sx={{ borderRadius: '0px', borderTopRightRadius: 0, borderTopLeftRadius: 0,  m: 0, backgroundColor: '#E2DED9' }}>
    <CardContent>
        <Typography variant='caption'>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={2}
          >
            <div style={ { display: 'flex'} }>
              <Avatar src={ avatarImageUrl(post.author.avatarImageId) } />
              <div style={ { paddingLeft: '1rem' } }>
                <Typography variant='caption' fontWeight='600'>{post.author.name}</Typography>
                <br />
                <Typography variant='caption'>{post.courseInfo?.name}</Typography>
              </div>
            </div>
            <div>{ new Date(post.createdOn).toDateString() }</div>
          </Stack>
        </Typography>
        <Typography style={ { marginTop: '1rem' }} >{ post.messageBody }</Typography>
    </CardContent>
</Card>))
}
